export default "__VITE_ASSET__66992ca4__"